import React from 'react'
import { Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import OperationalChange from './OperationalChange'
import Details from './Details'
import ImportOperation from './ImportOperation'
import EditContract from './EditContract'

const OperationalIndex = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/details'} component={Details} />
      <Route path={match.path + '/editcontract'} component={EditContract} />
      <Route path={match.path + '/importoperation'} component={ImportOperation} />
      <CacheRoute component={OperationalChange} />
    </CacheSwitch>
  )
}

export default OperationalIndex
